<template>
  <div class="pro-list">
    <div class="pro-container">
      <div class="search-box">
        <div class="item">
          <span class="text">商品標題：</span>
          <a-input style="width:200px;" placeholder="標題" v-model="para.productTitle"></a-input>
        </div>
        <div class="item">
          <span class="text">分類：</span>
          <a-select allowClear style="width:200px;" v-model="para.categoryId">
            <a-select-option :key="item.id" v-for="item in categoryList" :value="item.id">{{ item.categoryName }}
            </a-select-option>
          </a-select>
          <a-button style="margin-left:20px;" @click="search">搜索</a-button>
        </div>
      </div>
      <a-table :pagination="false" :loading="tbLoading" :data-source="list" row-key="id">
        <a-table-column
            :width="360"
            align="center"
            title="商品信息">
          <template slot-scope="row,item">
            <div class="pro-box">
              <img :src="item.bannerPicPath" alt="" class="pro-img">
              <p style="text-align: left;" class="pro-name">{{ item.productTitle }}</p>
            </div>
          </template>
        </a-table-column>
        <a-table-column
            align="center"
            title="商品分類"
            data-index="categoryName">
        </a-table-column>
        <a-table-column
            align="center"
            title="商品價格">
          <template slot-scope="row,item">
            <p class="red" v-if="item.priceStr">{{ item.priceStr }}</p>
            <p class="red" v-else>¥{{ (item.productPrice / 100).toFixed(2) }}元</p>
            <a-button v-if="item.skus.length" type="link" size="small" @click="lookSku(item)">查看规格</a-button>
          </template>
        </a-table-column>
        <a-table-column
            align="center"
            title="商品库存"
            data-index="inventoryNum">
        </a-table-column>
        <a-table-column
            align="center"
            title="商品销量"
            data-index="sales">
        </a-table-column>
        <a-table-column
            align="center"
            title="权限限制">
          <template slot-scope="row,item">
            <p v-if="item.limit">
              <span v-if="item.limit.userType === 1">游客</span>
              <span v-if="item.limit.userType === 2">注册用户</span>
              <span v-if="item.limit.userType === 3">会员</span>
            </p>
            <p v-else>无限制</p>
            <!--                        <p v-if="item.limit && item.limit.userType === 3">-->
            <!--                            <span style="color:#ff3657;font-size: 12px;" v-for="(item,index) in item.limit.vipType" :key="index">{{item.vipDesc}}</span>-->
            <!--                        </p>-->
          </template>
        </a-table-column>
        <a-table-column
            align="center"
            title="上架時間">
          <template slot-scope="row,item">
            {{ item.gmtCreated | trans-date }}
          </template>
        </a-table-column>
        <a-table-column
            align="center"
            title="操作">
          <template slot-scope="row,item">
            <a-space>
              <a-button size="small" @click="down(item)">下架</a-button>
              <a-button size="small" v-if="item.recommendState===-1" @click="recommend(item)">加入推荐</a-button>
              <a-button size="small" @click="preview(item)">预览</a-button>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
      <a-pagination :defaultPageSize="para.pageSize" :defaultCurrent="para.pageIndex" :total="total"
                    @change="currentChange"/>
      <a-modal
          title="商品SKU详情"
          :visible="showSku"
          :footer="null"
          @cancel="skuCancel"
      >
        <a-descriptions title="" bordered :column="1" size="small">
          <a-descriptions-item v-for="(item,index) in skuObj" :key="index" :label="item.skuDesc">
            库存：{{ item.inventoryNum }}<br>
            价格：{{ (item.productPrice / 100).toFixed(2) }}
          </a-descriptions-item>
        </a-descriptions>
      </a-modal>
      <a-modal
          :title="false"
          :getContainer="getContainer"
          :visible="showPreview"
          width="430px"
          dialogClass="preview-dia"
          :footer="null"
          :maskClosable="false"
          @cancel="previewCancel">
        <div class="html" v-if="info">
          <!--    swiper轮播图    -->
          <swiper class="swiper-container-box" ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item,index) in info.productImages" :key="index">
              <img class="img-content" :src="item" alt="">
            </swiper-slide>
          </swiper>
          <p class="title">{{ info.productTitle }}</p>
          <div class="tag-list">
            <p class="sub-title">商品规格/价格：</p>
            <a-tag color="blue" v-for="(item,index) in info.skus" :key="index">{{ item.skuDesc }} / <span style="color:#ff3657;">¥{{ item.productPrice }}</span></a-tag>
          </div>
          <div class="html-content">
            <p class="html-title">商品描述：</p>
            <div v-html="info.productDesc"></div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
// 引入swiper
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        // Some Swiper option/callback...
      },
      total: 0,
      showSku: false,
      tbLoading: false,
      list: [],
      para: {
        pageIndex: 1,
        pageSize: 8,
        productState: 20,
        categoryId: undefined,
        productTitle: undefined
      },
      categoryList: [],
      skuObj: [],
      showPreview: false,
      info: null,
    }
  },
  methods: {
    getContainer() {
      return document.getElementsByClassName('pro-list')[0]
    },
    preview(item) {
      let self = this;
      self.$http({
        method: 'get',
        url: '/manager/product/detail',
        params: {id: item.id},
      }).then(res => {
        this.info = res.data;
        this.showPreview = true;
      })
    },
    previewCancel() {
      this.info = null;
      this.showPreview = false;
    },
    recommend(item) {
      let self = this;
      this.$Confirm({
        title: '提示',
        content: '確定要将該商品加入推薦列表嗎？',
        onOk() {
          return new Promise((resolve, reject) => {
            self.$http({
              method: 'post',
              url: '/manager/product/update',
              data: {
                id: item.id,
                recommendState: 1
              }
            }).then(res => {
              self.$Message.success('操作成功');
              self.getList();
              resolve();
            }).catch(err => {
              reject()
            })
          })
        },
        onCancel() {
        },
      });
    },
    currentChange(val) {
      this.para.pageIndex = val;
      this.getList();
    },
    search() {
      this.para.pageIndex = 1;
      this.getList();
    },
    skuCancel() {
      this.skuObj.splice(0, this.skuObj.length)
      this.showSku = false;
    },
    lookSku(item) {
      this.skuObj.splice(0, this.skuObj.length)
      this.skuObj = JSON.parse(JSON.stringify(item.skus));
      this.showSku = true;
    },
    down(item) {
      let self = this;
      this.$Confirm({
        title: '提示',
        content: '確定要下架該商品嗎？',
        onOk() {
          return new Promise((resolve, reject) => {
            self.$http({
              method: 'post',
              url: '/manager/product/update',
              data: {
                id: item.id,
                productState: 10
              }
            }).then(res => {
              self.$Message.success('下架成功');
              self.getList();
              resolve();
            }).catch(err => {
              reject()
            })
          })
        },
        onCancel() {
        },
      });
    },
    getList() {
      let self = this;
      self.tbLoading = true;
      self.$http({
        method: 'post',
        url: '/manager/product/list',
        data: this.para,
      }).then(res => {
        self.tbLoading = false;
        self.list = res.data && res.data.list ? res.data.list : []
        self.list.forEach(item => {
          if (item.skus.length) {
            let str = ''
            let arr = []
            item.skus.forEach(sub => {
              arr.push(sub.productPrice)
            })
            arr.sort(function (a, b) {
              return a - b;
            })
            console.log(arr)
            if (arr.length > 1) {
              str = `¥${(arr[0] / 100).toFixed(2)}元-¥${(arr[arr.length - 1] / 100).toFixed(2)}元`
            } else {
              str = `¥${(arr[0] / 100).toFixed(2)}元`
            }
            item.priceStr = str;
          }
        })
        self.total = res.data && res.data.totalRows ? res.data.totalRows : 0
      })
    },
    getCategory() {
      let self = this;
      self.$http({
        method: 'get',
        url: '/manager/product/category/list',
      }).then(res => {
        self.categoryList = res.data ? res.data : []
      })
    },
  },
  created() {
    this.$emit('breadcrumbChange', ['商品管理', '已上架商品'])
    this.getList();
    this.getCategory();
  },
}
</script>
<style lang="less">
.pro-list {
  .preview-dia{
    .ant-modal-content{
      border-radius: 18px;
      overflow: hidden;
      .ant-modal-close-x{
        background-color: rgba(255,255,255,0.8);
        width: 30px;
        height:30px;
        line-height:30px;
      }
      .ant-modal-body{
        padding:0;
      }
    }
  }
  .html{
    width:430px;
    height:932px;
    overflow-y: auto;
    overflow-x: hidden;
    .html-content{
      padding:14px;
      .html-title{
        text-align: left;
        font-size: 14px;
        color:#333;
        margin-bottom:10px;
      }
    }
    .tag-list{
      padding:0 14px;
      .sub-title{
        font-size: 14px;
        color:#333;
        text-align: left;
      }
      .ant-tag{
        margin-bottom:10px;
      }
    }
    .title{
      font-size: 18px;
      color:#333;
      font-weight: bold;
      text-align: left;
      margin:14px 0;
      padding:0 14px;
    }
    .swiper-container-box{
      width:100%;
      height:430px;
      .img-content{
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
  }
  .pro-container {
    padding: 20px;
  }

  .search-box {
    margin-bottom: 20px;
    overflow: hidden;

    .item {
      float: left;
      margin-right: 20px;

      .text {
        font-size: 14px;
        color: #333;
      }
    }
  }

  .red {
    color: #ff3657;
  }

  .pro-box {
    display: flex;

    .pro-img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      display: block;
      margin-right: 20px;
    }

    .pro-name {
      color: #333;
      text-align: left;
      font-size: 14px;
    }
  }
}
</style>
